import React, { useEffect, useRef } from "react";

// Defers loading the video until it scrolls near the viewport, and pauses it
// when it scrolls away — keeps a page full of preview videos from downloading
// (and decoding) all at once on load.
const LazyVideo = ({ src, className, ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!video.getAttribute("src")) {
            video.setAttribute("src", src);
          }
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { rootMargin: "200px" }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, [src]);

  return (
    <video
      ref={ref}
      preload="none"
      loop
      muted
      playsInline
      className={className}
      {...rest}
    />
  );
};

export default LazyVideo;
